import React from 'react'
import {
    Create,
    CreateButton,
    Datagrid,
    DeleteWithConfirmButton,
    Edit,
    EditButton,
    ExportButton,
    List,
    maxLength,
    minLength,
    Pagination,
    required,
    ResourceComponentProps,
    sanitizeListRestProps,
    Show,
    ShowButton,
    SimpleForm,
    Tab,
    TabbedShowLayout,
    TextField,
    TextInput,
    TopToolbar,
    useListContext,
    useNotify,
    useRedirect,
    useRefresh
} from 'react-admin'

const ListActions = (props: any) => {
    const { className, exporter, filters, maxResults, ...rest } = props
    const { currentSort, resource, filterValues, basePath, total } = useListContext()
    return (
        <TopToolbar className={ className } { ...sanitizeListRestProps(rest) }>
            <CreateButton basePath={ basePath }/>
            <ExportButton disabled={ total === 0 } resource={ resource } sort={ currentSort }
                          filterValues={ filterValues } maxResults={ maxResults }/>
        </TopToolbar>
    )
}

export const FaqList = (props: any) => {
    return (
        <>
            <List
                { ...props }
                actions={ <ListActions/> }
                perPage={ 25 }
                pagination={ <Pagination rowsPerPageOptions={ [ 25, 50, 100 ] }/> }
                title="Faqs"
                bulkActionButtons={ false }
            >
                <Datagrid>
                    <TextField source="query"/>
                    <TextField source="value"/>
                    <ShowButton/>
                    <EditButton/>
                    <DeleteWithConfirmButton label=''/>
                </Datagrid>
            </List>
        </>
    )
}

export const FaqCreate = (props: ResourceComponentProps) => {

    const notify = useNotify()
    const redirect = useRedirect()
    const refresh = useRefresh()

    const onSuccess = () => {
        notify(`Successfully Created`)
        redirect('/faq')
        refresh()
    }

    return (
        <Create onSuccess={ onSuccess } { ...props }>
            <SimpleForm submitOnEnter={ false }>
                <TextInput
                    source="query"
                    label="Question"
                    validate={ [ required(), maxLength(256), minLength(1) ] }
                    fullWidth
                />
                <TextInput
                    source="value"
                    label="Answer"
                    minRows={4}
                    multiline
                    validate={ [ required(), minLength(1) ] }
                    fullWidth
                />
            </SimpleForm>
        </Create>
    )
}


export const FaqEdit = (props: ResourceComponentProps) => {

    return (
        <Edit { ...props }>
            <SimpleForm submitOnEnter={ false }>
                <TextInput
                    source="query"
                    label="Question"

                    validate={ [ required(), maxLength(256), minLength(1) ] }
                    fullWidth
                />
                <TextInput
                    source="value"
                    label="Answer"
                    minRows={4}
                    multiline
                    validate={ [ required(), minLength(1) ] }
                    fullWidth
                />
            </SimpleForm>
        </Edit>
    )
}

export const FaqShow = (props: ResourceComponentProps) => {

    return (
        <Show { ...props }>
            <TabbedShowLayout>
                <Tab label="Faqs">
                    <TextField label='Faq Query' source='query'/>
                    <TextField label='Faq Value' source='value'/>
                </Tab>
            </TabbedShowLayout>
        </Show>
    )
}
